import 'ssd-form';
import 'ssd-select';

export default class {

    constructor() {

        this.form = $('form[data-ajax-form]');
        this.selector = $('select[data-ssd-select]');

        if (this.form.length > 0) {
            this.setForm();
        }

        if (this.selector.length > 0) {
            this.setSelect();
        }

    }

    setForm() {
        this.form.ssdForm();
    }

    setSelect() {
        this.selector.ssdSelect();
    }

}